import { Currentlysale } from "../../Common/Data/ApexChart";
import CardHeaderComponent from "../Common/CardHeader";
import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import Chart from "react-apexcharts";
import { UserChart } from "../../Common/Data/ApexChart";
import Swal from "sweetalert2";

// import request from '../../Apis/request';
import { useState, useEffect } from "react";
import { fetchStatusList } from "../../../Apis/StatusListing";
import axios from "axios";
import { BaseURL, uniqueToken } from "../../../api/DataApis";


const IncomeChartClass = () => {

  const [ChargerData, setChargerData] = useState([]);
  const [Limit, setLimit] = useState(20);
  const [TotalCount, setTotalCount] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusListing, setStatusListing] = useState([]);


  const getStatusColors = (status) => {
    switch (status) {
      case 'NotAvailable':
      case 'Faulted':
        return '#dc3545'; // Red
      case 'Available':
      case 'Preparing':
      case 'Active':
        return '#28a745'; // Green
      case 'Charging':
        return '#ff9800'; // Orange
      case 'Finishing':
        return '#6f42c1'; // Purple
      case 'Deleted':
        return '#6c757d'; // Grey
      case 'InActive':
        return '#17a2b8'; // Light Blue
      default:
        return '#6f42c1'; // Default Grey for unhandled statuses
    }
  };
  


  const handleStatus = (e) => {
    setSelectedStatus(e.target.value);
  }
  
  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };

 // Define the fetchConnectors function outside the useEffect so it can be reused
const fetchConnectors = async (currentPage = 1, searchTerm = '') => {
  setLoading(true);

  const apiEndpoint = `${BaseURL}/chargers/charger-connectors?&connector_status=${selectedStatus}&searchText=${searchTerm}&limit=${Limit}`;

  try {
    const response = await axios.get(apiEndpoint, {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`,
      },
    });

    setChargerData(response.data.data || []);
    setLimit(response?.data?.limit);
    setTotalCount(response.data?.totalCount);
  } catch (error) {
    console.error("Error fetching ChargerData:", error);
  } finally {
    setLoading(false);
  }
};

// Handle the search form submission
const handleSearchSubmit = (e) => {
  e.preventDefault();  // Prevent default form submission
  fetchConnectors(1, searchTerm);  // Trigger the API call with search term on form submit
};

// Polling mechanism inside the useEffect
useEffect(() => {
  // Fetch connectors immediately when the component mounts
  fetchConnectors();  // Fetch all chargers for the current page

  // Polling function: fetch new data every 5 seconds
   // Set polling interval to 5 seconds

  // Clean up the interval when the component unmounts
  
}, [selectedStatus, searchTerm]);  // Re-run if selectedStatus or searchTerm changes

  const fetchStatusListing = async () => {
    setLoading(true);
    try {
      const statusData = await fetchStatusList();
      setStatusListing(statusData);
    } catch (error) {
      console.error("Error fetching classes:", error);
    } finally {
      setLoading(false);
    }
  };
// setStatusListing(res.data);
  useEffect(() => {
    fetchStatusListing();
  }, []);

  const buttonStyle = {
    padding: '5px 10px',
    borderRadius: '5px',
    width: '110px', // Set a fixed width to ensure uniform size
    height: '40px', // Set a fixed height
    border: 'none',
    textAlign: 'center'
  };
  return (
    <Fragment>
    <Col xl="12" className="box-col-12 des-xl-100 dashboard-sec">
      <Card className="income-card-new mt-3" style={{ width: "97%" }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
  {/* Chargers heading and Total Chargers button */}
  <div className="d-flex align-items-center">
    <h4 style={{ marginRight: "10px" }}>Chargers Connectors</h4> ({TotalCount}){/* Add margin to separate */}
 
  </div>

  {/* Search, Status select, and Search button */}
  <form className="d-flex" role="form" method="post" onSubmit={handleSearchSubmit}>
    {/* Search input */}
    {/* <div className="form-group" style={{ marginRight: "10px" }}>
      <input
        type="text"
        placeholder="Find Data Here."
        onChange={handleSearchChange}
        value={searchTerm}
        className="form-control"
        style={{ height: "38px", width: "200px" }} // Set consistent height
      />
    </div> */}

    {/* Status select */}
    <div className="form-group" style={{ marginRight: "10px" }}>
      <select
        className="form-select"
        style={{
          height: "38px", // Consistent height
          border: "1px solid black",
          borderRadius: "34px",
          width: "150px", // Adjust as needed
        }}
        onChange={handleStatus} // Handle the change as needed
      >
        <option value="">Select Connector Status</option>
        {statusListing.map((status, index) => {
          const statusKey = Object.keys(status)[0];
          const statusValue = status[statusKey];
          return (
            <option key={index} value={statusValue}>
              {statusValue}
            </option>
          );
        })}
      </select>
    </div>

    {/* Search button */}
    {/* <div className="form-group">
      <button 
        type="submit" 
        className="btn btn-primary" 
        style={{ height: "38px", lineHeight: "20px" }} // Set consistent height
      >
        Search
      </button>
    </div> */}
  </form>
</div>

            <div className="table-responsive">
                      
                      <table className="display dataTable" id="advance-1">
    <thead>
      <tr>
        <th>Sr. No</th>
        <th>Charger Name</th>
        <th>Station Name</th>
        <th>IMEI Number</th>
        <th>Connector Name</th>
        <th>Connector ID</th>
        <th>Status</th>
        <th>Created Date</th>
    </tr>
    </thead>
    <tbody>
      {ChargerData?.length === 0 ? (
        <tr>
          <td colSpan="8" className="text-center">No Data Available</td>
        </tr>
      ) : (
        ChargerData?.map((connector, index) => (
          <tr key={index}>
            <td style={{ whiteSpace: 'nowrap' }}>{index + 1}</td>
         
            <td>{connector?.charger_name}</td>
            <td>{connector?.station_name}</td>
            <td>{connector?.imei_number}</td>
            <td>{connector?.connector_name}</td>
            <td>{connector?.connectorId}</td>
         
           
           <td>
            <button
  className="btn"
  style={{
    backgroundColor: getStatusColors(connector.connector_status),  // Background color based on status
    color: 'Black',                           // Ensure the text is readable on all backgrounds
    border: 'none',                           // Optional: removes border for a cleaner look
    width: '100px',                           // Fixed width
    height: '40px',                           // Fixed height
    padding: '0',                             // Ensure no extra padding affects size
    lineHeight: '40px',                       // Center text vertically
    textAlign: 'center'                       // Center text horizontally
  }}
>
  {connector.connector_status}
</button>

</td>
<td>{connector?.createdAt}</td>
  
      
          </tr>
        ))
      )}
    </tbody>
  </table>
  
                      </div>
                  </Card>
      </Col>
    </Fragment>
  );
};
export default IncomeChartClass;
